import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './theme-and-settings.scss';

// Components
import { ThemeSettings } from './children/theme-settings/theme-settings';
import { WidgetSettings } from './children/widget-settings/widget-settings';

// Store entities
import { fetchWidgetSettings } from '../../../../store/widget-settings/widget-settings.thunks';
import { getWidgetSettingsState } from '../../../../store/widget-settings/widget-settings.selectors';

type TThemeAndSettingsProps = {};

export const ThemeAndSettings: FC<TThemeAndSettingsProps> = (
  {}: TThemeAndSettingsProps
) => {
  const { widgetSettings, loading } = useSelector(getWidgetSettingsState);

  const dispatch = useDispatch<any>();

  const loadWidgetSettings = (): void => {
    dispatch(fetchWidgetSettings());
  }

  useEffect(() => {
    loadWidgetSettings();
  }, []);

  return (
    <div className="theme-and-settings">
      <div className={ `theme-and-settings--loader theme-and-settings--loader-${ loading ? 'show' : 'hide' }` }>
        <SpinElement fullHeight={ true }/>
      </div>
      <div className="theme-and-settings--title">
        Theme & Widget
      </div>
      { widgetSettings && <div className="theme-and-settings--body">
        <div className="body-item">
          <ThemeSettings theme_settings={ widgetSettings?.theme_settings } loading={ loading }/>
        </div>
        <div className="body-item">
          <WidgetSettings widget_settings={ widgetSettings } loading={ loading }/>
        </div>
      </div> }
    </div>
  );
}
